module.exports = __webpack_public_path__ + "img/ikonka_wypadek_smiertelny.a276132c.svg";